export default function EmptyPage() {
  return <></>;
}
